import React from 'react'

const text = props => <div className='centered'>
  <h2 className='header-title'>about</h2>
</div>

export default text